import React, { memo } from 'react';
import { Handle,Position } from 'react-flow-renderer';
import { ReactComponent as ListIcon } from '../../../assets/icons/add.svg'
import { ReactComponent as DeleteIcon } from '../../../assets/icons/close.svg'

//@ts-ignore
export default memo(({ data }) => {
    const customNodeStyles = {
        block: { 
            background: '#2a3d42',
            color: '#a2a9a8',
            borderRadius: '5px',
            minWidth: '5rem',
        },
        title: {
            margin: 0,
            fontSize: '14px',
            color: '#fff',
            fontFamily: 'Catamaran',
            letterSpacing: '0.5px',
            padding: '10px',
            paddingBottom: '2px',
            textAlign: 'center' as 'center',
        },
        inputsBlock: {
            padding: '15px',
            fontSize: '12px',

        },
        inputBlock: {
            marginBottom: '10px',
        },
        input: {
            padding: '4px 7px 4px 5px',
            borderRadius: '3px',
            maxWidth: '7rem',
            border: '1px solid #d5dbdc',
            fontSize: '12px',
            color:'#d5dbdc',
            background:'#252d2f',
            //color: 'lightgrey'
        },
        label: {
            paddingRight: '5px',
        },
        handleTopCenter: {
            width: "30%",
            height: "20px", 
            borderTopRightRadius: "5px", 
            borderTopLeftRadius: "5px", 
            borderBottomLeftRadius: "unset", 
            borderBottomRightRadius: "unset", 
            top: "-25px", 
            border: "unset", 
            background: "#586565",
        },
        handleBottomRight: { 
            width: "30%", 
            height: "20px", 
            borderBottomRightRadius: "5px", 
            borderBottomLeftRadius: "5px", 
            borderTopLeftRadius: "unset", 
            borderTopRightRadius: "unset", 
            bottom: "-25px", 
            border: "unset", 
            background: "#874045",
            left:"75%"
        },
        handleBottomLeft: { 
            width: "30%", 
            height: "20px", 
            borderBottomRightRadius: "5px", 
            borderBottomLeftRadius: "5px", 
            borderTopLeftRadius: "unset", 
            borderTopRightRadius: "unset", 
            bottom: "-25px", 
            border: "unset", 
            background: "#286255",
            left:"25%"
        }
    };
    const onChange = (value, index) => {
        data.block.inputs[index].value = value;
    }

    const onDelete = (id) => {
        data.onDeleteNode(id);
    }

    return (
        <div style={customNodeStyles.block} className="diamond-node">
            <Handle type="target" position={Position.Top} style={customNodeStyles.handleTopCenter}/>
            <p style={customNodeStyles.title} className="cond">If</p>
            <DeleteIcon onClick={e => onDelete(data.id)} style={{ position: "absolute", top: "10", right: "10", width: "20px", cursor: "pointer"}} />
            <div style={customNodeStyles.inputsBlock}>
     
                <div style={customNodeStyles.inputBlock}>	
                    {data.block.inputs?.map((item, i) => {
                        return <div key={i} style={{ marginBottom: "7px"}}>
                            <label style={customNodeStyles.label}>{item.label}</label>
                            <input type="text" 
                                style={customNodeStyles.input}
                                defaultValue={item.value} 
                                className="nodrag"
                                data-id={data.id} 
                                data-key={item.label}
                                onChange={(e)  => onChange(e.target.value, i)}
                            />
                            <ListIcon style={{ width:"20px", fill: "#c7c7c7", position:"relative", left: "4", top: "6", cursor: "pointer" }} />
                        </div>

                        
                    })} 
                </div>
            </div>
            <div>
                <Handle
                type="source"
                position={Position.Bottom}
                style={customNodeStyles.handleBottomLeft}
                id="conditionTrue"
                /> 
                <Handle
                type="source"
                position={Position.Bottom}
                style={customNodeStyles.handleBottomRight}
                id="conditionFalse"
                /> 
            </div>
        </div>
    );
});
